import {StyleSheet} from 'react-native';
export default StyleSheet.create({
  dividerStyle: (color, top, height) => ({
    marginHorizontal: 0,
    height: height,
    backgroundColor: color,
    marginTop: top,
  }),
});
